import { GetServerSideProps } from "next";
import { ProfileAchievementsPage } from "../../features/profile/achievements-page/achievements-page";
import { getAuth0AccessToken } from "../../lib/auth0";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";

export default ProfileAchievementsPage;

export const getServerSideProps: GetServerSideProps<
  Awaited<ReturnType<typeof ProfileAchievementsPage.prefetchData>>,
  { usernameOrId: string }
> = withLogging(async (context) => {
  const accessToken = await getAuth0AccessToken(context.req, context.res);
  const props = await ProfileAchievementsPage.prefetchData(
    context.params,
    accessToken
  );

  return {
    props,
  };
});
